module.exports = __webpack_public_path__ + "static/media/Peter Wong.7c32b735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Peter Wong.jpg
// module id = 178
// module chunks = 0